import { Formik } from "formik";
import React, { useContext, useState } from "react";
import { useHistory, NavLink } from "react-router-dom";
import { LoginRequest } from "../../app/models/signin/login-request";
import { UserProfileFormValues } from "../../app/models/user-profile";
import { Store } from "../../app/stores/store-root";

export const Login = () => {
  const store = useContext(Store);
  const { login } = store.Users;
  const [user, setUser] = useState(new UserProfileFormValues());
  const [error, setError] = useState<any | undefined>(undefined);
  const history = useHistory();

  const signIn = (request: UserProfileFormValues) => {
    const user = login(new LoginRequest(request.Email, request.Password))
      .then((user: any) => {
        if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          history.push("/confirm");
        } else {
          history.push("/");
        }
      })
      .catch((error) => {
        console.log("error thrown");
        setError(error);
      });
  };

  return (
    <Formik
      initialValues={user}
      enableReinitialize={true}
      onSubmit={(values) => {
        signIn(values);
      }}
    >
      {(formik: any) => (
        <form onSubmit={formik.handleSubmit}>
          <div className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
            <div className="mx-auto w-full max-w-sm lg:w-96">
              <div>
                <img
                  className="h-12 w-auto hidden"
                  src="./favicon.svg"
                  alt="Workflow"
                />
                <h2 className="mt-6 text-3xl leading-9 font-extrabold text-gray-900">
                  Sign in to your account
                </h2>
              </div>
              {error ? (
                <div className="rounded-md bg-yellow-100 p-4 mt-8 border border-yellow-800">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      {/* Heroicon name: exclamation */}
                      <svg
                        className="h-5 w-5 text-yellow-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="ml-3">
                      <h3 className="text-sm leading-5 font-medium text-yellow-800">
                        Attention needed
                      </h3>
                      <div className="mt-2 text-sm leading-5 text-yellow-700">
                        <p>{error?.message}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              <div className="mt-8">
                <div className="mt-6">
                  <div className="space-y-6">
                    <div>
                      <label
                        htmlFor="Email"
                        className="block text-sm font-medium leading-5 text-gray-700"
                      >
                        User name
                      </label>
                      <div className="mt-1 rounded-md shadow-sm">
                        <input
                          {...formik.getFieldProps("Email")}
                          name="Email"
                          id={'Email'}
                          required
                          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                        />
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor="Password"
                        className="block text-sm font-medium leading-5 text-gray-700"
                      >
                        Password
                      </label>
                      <div className="mt-1 rounded-md shadow-sm">
                        <input
                          {...formik.getFieldProps("Password")}
                          id="Password"
                          name="Password"
                          type="password"
                          required
                          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                        />
                      </div>
                    </div>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <input
                          id="remember_me"
                          type="checkbox"
                          className="form-checkbox h-4 w-4 text-gray-600 transition duration-150 ease-in-out"
                        />
                        <label
                          htmlFor="remember_me"
                          className="ml-2 block text-sm leading-5 text-gray-900"
                        >
                          Remember me
                        </label>
                      </div>
                      <div className="text-sm leading-5">
                        <NavLink
                          to={'/forgot'}
                          className="font-medium text-gray-600 hover:text-gray-500 focus:outline-none focus:underline transition ease-in-out duration-150"
                        >
                          Forgot your password?
                        </NavLink>
                      </div>
                    </div>
                    <div>
                      <span className="block w-full rounded-md shadow-sm">
                        <button
                          type="submit"
                          id={'signin'}
                          className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-gray-800 hover:bg-gray-600 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700 transition duration-150 ease-in-out font-bold"
                        >
                          Sign in
                        </button>
                                 <label
                                     htmlFor="terms and conditions"
                                     className="ml-2 block text-sm leading-5 text-gray-900"
                                 >
                               < h2 className="mt-6 text-3xl leading-9 font-extrabold text-gray-900"> Terms and Conditions </h2>

                              The User is solely responsible for maintaining the confidentiality and security of the User Account, and agrees to immediately notify the managers of any security breach of your User Account!
                                 <div></div>

                                     < h2 className="mt-6 text-3xl leading-9 font-extrabold text-gray-900"> Attention </h2>
                                     You must agree to ensure that you <b> logout </b> from your account at the end of each session! You are responsible for any password misuse or any unauthorized access.
                          </label>
                      </span>
                    </div>

                      <div >
                          <img
                              className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-gray-800 hover:bg-gray-600 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700 transition duration-150 ease-in-out font-bold"
                              src="./sabuur-hills.jpeg"
                              alt="data"
                          />
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
